import {
	Component,
	OnInit,
	HostBinding,
	Input,
	AfterViewInit,
	ChangeDetectionStrategy
} from '@angular/core';
import { LayoutConfigService } from '../../../../config/_core/services/layout-config.service';
import * as objectPath from 'object-path';
import { Router } from '@angular/router';
import { UtilsHCM_APService } from '../../../pages/HCMModuleApp/_core/utils/UtilsHCM_AP.service';
import { PermissionViewActionService } from '../../../../shared/services/permission-view-action.service';
import { Navigation } from '../../../pages/auth/_core/interfaces/navigation';

@Component({
	selector: 'm-topbar',
	templateUrl: './topbar.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[UtilsHCM_APService]
})
export class TopbarComponent implements OnInit, AfterViewInit {
	@HostBinding('id') id = 'm_header_nav';
	@HostBinding('class')
	classes = 'm-stack__item m-stack__item--fluid m-header-head';

	@Input() searchType: any;

	constructor(
		private layoutConfigService: LayoutConfigService,
		private router: Router,
		private utilsService: UtilsHCM_APService,
		public pvas: PermissionViewActionService,
	) {
		this.layoutConfigService.onLayoutConfigUpdated$.subscribe(model => {
			const config = model.config;
			this.searchType = objectPath.get(config, 'header.search.type');
		});
	}
	validViewAction = this.pvas.validViewAction;
	viewsActions: Array<Navigation> = [];

    showTableCargaMasiva() {
		const dialogRef = this.utilsService._tabla_carga_masiva('Cargas Masivas');
		dialogRef.afterClosed().subscribe(res => {});
	}

	ngOnInit(): void {
		this.viewsActions = this.pvas.get();
		//console.log(this.viewsActions)
	}

	ngAfterViewInit(): void {}
}
